import { ContainerResponseDto } from '@planning/app/api'
import { containerService } from '@planning/services'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetContainersByIdsQuery implements IQueryMessage {
  static type = 'GetContainersByIdsQuery'
  type = GetContainersByIdsQuery.type

  constructor(public ids: number[]) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

export const getContainersByIdsQueryHandler: IQueryHandler<
  GetContainersByIdsQuery,
  IEvent<ContainerResponseDto[]>
> = async query => {
  const data = await containerService.getByIds(query.ids)

  return new Event(GetContainersByIdsQuery.type, data)
}
